import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { homeGuard } from './core/navigation/home.guard';
import { APP_PATHS, PAGE_ROUTES } from './core/routing/app-paths';
import { DEV_ROUTES } from './dev/dev.routes';
import { AUTH_ROUTES } from './features/auth/auth.routes';

/**
 * Only Vijay edits this file. Use loadChildren / loadComponent only; never import a component.
 * Page routes live in features/<area>/<area>.routes.ts and carry data.page.
 * The catch-all `**` must stay last: a route added below it never matches.
 */
export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./shared/ui/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: APP_PATHS.noAccess,
        loadComponent: () =>
          import('./core/no-access/no-access.component').then((m) => m.NoAccessComponent),
        title: 'No access | Sales Portal',
      },
      {
        path: PAGE_ROUTES['order-entry'],
        loadChildren: () =>
          import('./features/order-entry/order-entry.routes').then((m) => m.ORDER_ENTRY_ROUTES),
      },
      {
        path: PAGE_ROUTES['edit-profile'],
        loadChildren: () =>
          import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
      },
      {
        path: PAGE_ROUTES.archive,
        loadChildren: () =>
          import('./features/archive/archive.routes').then((m) => m.ARCHIVE_ROUTES),
      },
      {
        path: PAGE_ROUTES['view-invoice-sales'],
        loadChildren: () =>
          import('./features/view-invoice-sales/view-invoice-sales.routes').then((m) => m.VIEW_INVOICE_SALES_ROUTES),
      },
      {
        path: PAGE_ROUTES['view-invoice-corporate'],
        loadChildren: () =>
          import('./features/view-invoice-corporate/view-invoice-corporate.routes').then(
            (m) => m.VIEW_INVOICE_CORPORATE_ROUTES,
          ),
      },
      { path: '', pathMatch: 'full', canActivate: [homeGuard], children: [] },
      ...DEV_ROUTES,
    ],
  },

  ...AUTH_ROUTES,

  {
    path: '**',
    loadComponent: () =>
      import('./core/not-found/not-found.component').then((m) => m.NotFoundComponent),
    title: 'Page not found | Sales Portal',
  },
];
